module.exports = __webpack_public_path__ + "img/home-visual-01.150e9821.png";